import React, { useEffect } from 'react';
import cn from 'classnames';

import styles from './FlippableCoin.module.scss';

import coinDuelSvg from '@assets/svg/coin-duel.svg';
import coinAnaSvg from '@assets/svg/coin-ana.svg';
import flipSound from '@assets/audio/coinflip.mp3';
// import useSound from 'use-sound';

interface Props {
  result?: 'heads' | 'tails' | undefined;
}

export default function FlippableCoin(props: Props): JSX.Element {
  console.log(props);

  // const [play] = useSound(flipSound);
  //     const [side, setSide] = useState("");
  //   const testFlip = async () => {
  //     setSide("");
  //     var flipResult = Math.random();

  //     setTimeout(function () {
  //       if (flipResult <= 0.5) {
  //         setSide("duel");
  //         console.log("it is duel");
  //       } else {
  //         setSide("ana");
  //         console.log("it is ana");
  //       }
  //     }, 100);
  //   };
  useEffect(() => {
    const audi = new Audio(flipSound);
    audi.play();
  }, []);

  return (
    <div
      className={cn(styles.coin, {
        [styles.pending]: !props.result,
        [styles.duel]: props.result == 'heads',
        [styles.ana]: props.result == 'tails',
      })}
      //   onClick={testFlip}
      style={props.result && props.result === 'tails' ? { transform: 'rotateY(180deg)' } : {}}
    >
      <div className={styles.duel}>
        <img src={coinDuelSvg} className={styles.icon} alt='Duel side wins' />
      </div>
      <div className={styles.ana}>
        <img src={coinAnaSvg} className={styles.icon} alt='Ana side wins' />
      </div>
    </div>
  );
}
